import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AnimationService, AnimationType } from '../../animation.service';
import { C3Service } from '../../c3.service';
import { PaneChild } from '../pane/pane.component';

interface Types {
  id: AnimationType;
  name: string;
}

@Component({
    selector: 'app-animation-editor',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './animation-editor.component.html',
    styleUrls: ['./animation-editor.component.css'],
    standalone: false
})
export class AnimationEditorComponent extends PaneChild {
  private _c3Service: C3Service;
  private _animationService: AnimationService;
  private _type: AnimationType = AnimationType.State;
  private _types = [
    { id: AnimationType.State, name: 'State' },
    { id: AnimationType.ParticleTrace, name: 'Particle Trace' },
    // { id: AnimationType.ModeShape, name: "Mode Shape" },
  ];

  public get types(): Types[] {
    return this._types;
  }
  public get type(): AnimationType {
    return this._type;
  }
  public get isState(): boolean {
    return this._type === AnimationType.State;
  }
  public get isParticleTrace(): boolean {
    return this._type === AnimationType.ParticleTrace;
  }
  public get states(): ReadonlyArray<cee.ug.StateInfo> {
    return this._c3Service.states;
  }
  public get fromState(): number {
    return this._animationService.stateAnimationHandler.from;
  }
  public get toState(): number {
    return this._animationService.stateAnimationHandler.to;
  }
  public get skipBy(): number {
    return this._animationService.stateAnimationHandler.skipBy;
  }
  public get numSteps(): number {
    return this._animationService.particleTraceAnimationHandler.numSteps;
  }

  public constructor(c3Service: C3Service, animationService: AnimationService) {
    super();
    this._c3Service = c3Service;
    this._animationService = animationService;
  }

  public typeChanged(value: string): void {
    this._type = parseInt(value, 10);
  }

  public fromStateChanged(value: string): void {
    this._animationService.stateAnimationHandler.from = parseInt(value, 10);
  }

  public toStateChanged(value: string): void {
    this._animationService.stateAnimationHandler.to = parseInt(value, 10);
  }

  public skipByChanged(value: number): void {
    this._animationService.stateAnimationHandler.skipBy = value;
  }

  public numStepsChanged(value: number): void {
    this._animationService.particleTraceAnimationHandler.numSteps = value;
  }

  public apply(): void {
    this._animationService.getHandler(this._type).apply();
  }

  public remove(): void {
    this._animationService.removeAnimation();
    this.close();
  }

  protected override onVisibleChanged(visible: boolean): void {
    if (visible && this._animationService.curAnimationType !== undefined) {
      this._type = this._animationService.curAnimationType;
    }
  }
}
